import { config } from "@/config";

/**
 * Where the buyer site lives for whatever environment this backoffice is.
 *
 * VITE_CLIENT_URL is not set anywhere, so the config default would send stage
 * to the production portal and open the wrong order. The two hosts are the
 * same name apart from the prefix — backoffice.stage.dommek.com is
 * stage.dommek.com — so strip it, and keep the config value for localhost and
 * anything unexpected.
 */
export const portalOrigin = (): string => {
  if (typeof window !== "undefined") {
    const { protocol, host } = window.location;
    if (host.startsWith("backoffice.")) {
      return `${protocol}//${host.slice("backoffice.".length)}`;
    }
  }
  return config.CLIENT_URL;
};
